import { createReducer, on } from '@ngrx/store';
import * as UserPermissionsActions from './user-permissions.actions';
import { userPermission } from 'src/app/shared/interfaces/userPermission.interface';

export interface UserPermissionsState {
  response: userPermission[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: userPermission[] };
}

export const initialState: UserPermissionsState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const userPermissionsReducer = createReducer(
  initialState,
  on(UserPermissionsActions.loadUserPermissionsByLoggedUser, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(UserPermissionsActions.loadUserPermissionsSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(UserPermissionsActions.loadUserPermissionsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(UserPermissionsActions.loadUserPermissionsSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
